import type {
  RiskReductionMeasurePerformanceLevel,
  RiskReductionMeasureType,
} from '@/shared/hooks/api/machineryDirectiveCompliance'

export type RiskReductionMeasureTypeFilter =
  | 'all'
  | RiskReductionMeasureType

export type RiskReductionMeasureSourceFilter = 'all' | 'USER' | 'STANDARD'

export type RiskReductionMeasureDependsOnControlSystemFilter =
  | 'all'
  | 'yes'
  | 'no'

export type RiskReductionMeasureSafetyFunctionFilter =
  | 'all'
  | 'assigned'
  | 'not_assigned'

export type RiskReductionMeasurePlrFilter =
  | 'all'
  | RiskReductionMeasurePerformanceLevel
  | 'none'

export type RiskReductionMeasureLinkedToHazardsFilter =
  | 'all'
  | 'linked'
  | 'not_linked'

export type RiskReductionMeasureListFilters = {
  measureType: RiskReductionMeasureTypeFilter
  source: RiskReductionMeasureSourceFilter
  ehsrClauseIds: string[]
  includeNoEhsr: boolean
  dependsOnControlSystem: RiskReductionMeasureDependsOnControlSystemFilter
  safetyFunction: RiskReductionMeasureSafetyFunctionFilter
  plr: RiskReductionMeasurePlrFilter
  linkedToHazards: RiskReductionMeasureLinkedToHazardsFilter
}

export const defaultRiskReductionMeasureListFilters: RiskReductionMeasureListFilters =
  {
    measureType: 'all',
    source: 'all',
    ehsrClauseIds: [],
    includeNoEhsr: false,
    dependsOnControlSystem: 'all',
    safetyFunction: 'all',
    plr: 'all',
    linkedToHazards: 'all',
  }

export function countActiveRiskReductionMeasureListFilters(
  filters: RiskReductionMeasureListFilters
): number {
  let count = 0
  if (filters.measureType !== 'all') {
    count++
  }
  if (filters.source !== 'all') {
    count++
  }
  if (filters.ehsrClauseIds.length > 0 || filters.includeNoEhsr) {
    count++
  }
  if (filters.dependsOnControlSystem !== 'all') {
    count++
  }
  if (filters.safetyFunction !== 'all') {
    count++
  }
  if (filters.plr !== 'all') {
    count++
  }
  if (filters.linkedToHazards !== 'all') {
    count++
  }
  return count
}
